import { render, staticRenderFns } from "./BeforeStarting.vue?vue&type=template&id=8c5384b4&scoped=true&"
import script from "./BeforeStarting.vue?vue&type=script&lang=ts&"
export * from "./BeforeStarting.vue?vue&type=script&lang=ts&"
import style0 from "./BeforeStarting.vue?vue&type=style&index=0&id=8c5384b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5384b4",
  null
  
)

export default component.exports